import {
  BellOutlined,
  QuestionCircleOutlined,
  PartitionOutlined,
  CheckSquareOutlined,
  ClockCircleOutlined,
  HomeOutlined,
  TeamOutlined,
  AimOutlined,
  MessageOutlined,
  RiseOutlined,
  TrophyOutlined,
  SolutionOutlined,
} from '@ant-design/icons';
import { ShellChrome } from './ShellChrome';
import { navItem } from './navItem';
import { useCollaborationNav } from './useCollaborationNav';

/**
 * Manager self-service (PRD §5.7, FR-MSS-02).
 *
 * A manager's job in this product is approvals and awareness: who is off, who
 * is asking to be, and whose attendance needs a decision. The shell is built
 * around the inbox because that is the thing with a queue behind it.
 *
 * What a manager cannot see is as deliberate as what they can. FR-MSS-02 is
 * explicit that managers see work data, not identity documents or salary — and
 * the server enforces it: a leave reason is SENSITIVE and never reaches this
 * shell at all.
 */
export function ManagerShell() {
  const collaboration = useCollaborationNav('/mss');
  return (
    <ShellChrome
      shell="mss"
      navItems={[
        navItem('/mss', 'Home', <HomeOutlined />),
        ...collaboration,
        navItem('/mss/approvals', 'Approvals', <CheckSquareOutlined />),
        navItem('/mss/team', 'My team', <TeamOutlined />),
        navItem('/mss/org-chart', 'Org chart', <PartitionOutlined />),
        navItem('/mss/claims', 'Expense claims', <SolutionOutlined />),
        navItem('/mss/performance', 'Reviews', <TrophyOutlined />),
        navItem('/mss/goals', 'Goals', <AimOutlined />),
        navItem('/mss/feedback-requests', 'Feedback asked of me', <MessageOutlined />),
        navItem('/mss/improvement-plans', 'Improvement plans', <RiseOutlined />),
        navItem('/mss/attendance', 'My attendance', <ClockCircleOutlined />),
        navItem('/mss/notifications', 'Notifications', <BellOutlined />),
        navItem('/mss/help', 'Get help', <QuestionCircleOutlined />),
      ]}
    />
  );
}
